import {Injectable} from '@angular/core';
import {DocumentEditorType, DocumentPermission} from "@pt/pt-models";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {PermissionManager} from "./permission-manager";
import { AvailableOperations } from 'it/primatoo/openapi/api/org/schemas/common/AvailableOperations';
import {
  AiAssessmentsService,
  AppAssessmentsService, BusinessProjectManagementService, CovidAssessmentsService,
  GlobalMeasureChecksService,
  TreatmentService
} from '@pt/api-client';

@Injectable({
  providedIn: 'root'
})
export class DocumentPermissionService {

  constructor(
    private treatmentService: TreatmentService,
    private appAssessmentService: AppAssessmentsService,
    private aiAssessmentService: AiAssessmentsService,
    private globalMeasureChecksService: GlobalMeasureChecksService,
    private covidAssessmentsService: CovidAssessmentsService,
    private permissionManager: PermissionManager) {

  }

  public getDocumentPermission(docType: DocumentEditorType, docId: number): Observable<DocumentPermission> {
    const service: BusinessProjectManagementService = this.getBusinessProjectManagementService(docType);
    return service.getDocUserPermission(docId).pipe(map((doc) => {
      return this.toDocPermission(docType, doc);
    }))
  }

  public toDocPermission(docType: DocumentEditorType, doc: AvailableOperations): DocumentPermission {
      switch (docType) {
        case DocumentEditorType.AI_ASSESSMENT:
          return this.permissionManager.aiAssessmentPermission(doc);
        case DocumentEditorType.APP_ASSESSMENT:
          return this.permissionManager.appAssessmentPermissionV2(doc);
        case DocumentEditorType.GLOBAL_MEASURE_CHECK:
          return this.permissionManager.globalMeasureCheckPermission(doc);
        case DocumentEditorType.TREATMENT:
          return this.permissionManager.treatmentPermission(doc);
        case DocumentEditorType.COVID_ASSESSMENT:
          return this.permissionManager.covidAssessmentPermission(doc);
        default:
      }
      return undefined;
  }

  public getBusinessProjectManagementService(type: DocumentEditorType) {
    switch (type) {
      case DocumentEditorType.AI_ASSESSMENT:
        return this.aiAssessmentService;
      case DocumentEditorType.APP_ASSESSMENT:
        return this.appAssessmentService;
      case DocumentEditorType.GLOBAL_MEASURE_CHECK:
        return this.globalMeasureChecksService;
      case DocumentEditorType.TREATMENT:
        return this.treatmentService;
      case DocumentEditorType.COVID_ASSESSMENT:
        return this.covidAssessmentsService;
      default:
    }
  }

}
